// 提现和视频彩铃统付的接口
import request from "@/utils/request";

// 银行卡列表查询接口
export function bankListGet(params) {
  return request({
    url: "/bankinfo/authToken/list",
    method: "get",
    params: params,
    metaValue: "银行卡列表查询接口"
  });
}

// 银行卡新增接口
export function bankListAdd(params) {
  return request({
    url: "/bankinfo/authToken/saveinfo",
    method: "post",
    params: params,
    metaValue: "银行卡新增接口"
  });
}

// 银行卡删除接口
export function bankListDel(params) {
  return request({
    url: "bankinfo/authToken/" + params,
    method: "delete",
    metaValue: "银行卡删除接口"
  });
}

// 银行卡修改接口
export function bankListUpdate(params) {
  return request({
    url: "/bankinfo/authToken/updateInfo",
    method: "put",
    data: params,
    metaValue: "银行卡修改接口"
  });
}

// 好灵工实名认证
export function userCertification(params) {
  return request({
    url: "/lhyg/authToken/certification",
    method: "post",
    params: params,
    metaValue: "灵活用工实名认证"
  });
}

// 好灵工灵活用工提现
export function getMoney(params) {
  return request({
    url: "/lhyg/authToken/getMoney",
    method: "post",
    params: params,
    metaValue: "灵活用工提现"
  });
}

// 易畅行实名认证
export function userCertificationYcx(params) {
  return request({
    url: "/bosskg/authToken/certificationBosskg",
    method: "post",
    params: params,
    metaValue: "灵活用工实名认证"
  });
}

// 易畅行提现
export function getMoneyYcx(params) {
  return request({
    url: "/bosskg/authToken/getbosskgMoney",
    method: "post",
    params: params,
    metaValue: "灵活用工提现"
  });
}

// 云账户获取用工协议
export function getBookYzh(params) {
  return request({
    url: "/yunzh/authToken/apiUserSignContract",
    method: "get",
    params: params,
    metaValue: "云账户获取用工协议"
  });
}

// 云账户实名认证
export function userCertificationYzh(params) {
  return request({
    url: "/yunzh/authToken/apiUserSign",
    method: "post",
    params: params,
    metaValue: "云账户实名认证"
  });
}

// 云账户提现
export function getMoneyYzh(params) {
  return request({
    url: "/yunzh/authToken/getyunzhMoney",
    method: "post",
    params: params,
    metaValue: "云账户提现"
  });
}

// 灵活用工提现记录
export function getMoneyHistory(params) {
  return request({
    url: "/lhyg/authToken/getMoneyHistory",
    method: "post",
    params: params,
    metaValue: "灵活用工提现记录"
  });
}

// 灵活用工提现详情
export function getMoneyHistoryDetail(params) {
  return request({
    url: "/lhyg/authToken/getMoneyDetail",
    method: "post",
    params: params,
    metaValue: "灵活用工提现详情"
  });
}

// 宣传海报列表
export function posterListNew(params) {
  return request({
    url: "/poster/authToken/list",
    method: "get",
    params: params,
    metaValue: "宣传海报列表"
  });
}

// 微信红包提现
export function wxHongbaoForCash(params) {
  return request({
    url: "/lhyg/authToken/getWXMoney",
    method: "post",
    params: params,
    metaValue: "微信红包提现"
  });
}

// 判断用户是否关注公众号
export function isSubscribe(params) {
  return request({
    url: "/wxauth/isSubscribe",
    method: "get",
    params: params,
    metaValue: "用户是否关注公众号"
  });
}



// WEBPACK FOOTER //
// ./src/api/api/mine.js